import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import {
  catchError,
  finalize,
  firstValueFrom,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { RegisterStepType } from 'src/app/domain/enums/register-step-types.enum';
import { IndividualAccountDto } from 'src/app/domain/models/dto/individual-account.dto';
import { AuthenticationService } from 'src/app/shared/services';
import { IndividualAccountService } from 'src/app/shared/services/individual-account.service';
import { RegisterService } from 'src/app/shared/services/register.service';

@Component({
  selector: 'app-individual-documents',
  templateUrl: './individual-documents.component.html',
  styleUrls: ['./individual-documents.component.scss'],
})
export class IndividualDocumentsComponent implements OnInit {
  private readonly notifier: NotifierService;
  tenant: string = '';
  public loading: boolean;
  confirmData = false;

  individualDocument: any = null;
  individualAccount: IndividualAccountDto;
  @ViewChild('documentFile') documentFileRef: ElementRef;
  isMobile: boolean;
  isValidDocument: boolean = false;
  loadingValidation: boolean = false;

  get individualId() {
    return +this.authService.getIndividualId();
  }

  get userId() {
    return this.authService.getCurrentUserId();
  }

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,

    private readonly authService: AuthenticationService,
    private readonly registerService: RegisterService,
    private readonly individualAccountService: IndividualAccountService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });

    this.isMobile = window.innerWidth < 820 ? true : false;

    this.individualAccountService.get(this.individualId).subscribe({
      next: (res) => {
        this.individualAccount = res.data;
      },
    });
  }

  resetDocumentFile() {
    this.documentFileRef.nativeElement.value = '';
    this.individualDocument = null;
  }

  async uploadDocumentFile(id: number, event: Event): Promise<void> {
    const input = event.currentTarget as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    this.individualDocument = file;
    this.isValidDocument = false;
    this.loadingValidation = true;

    try {
      const { data } = await firstValueFrom(
        this.individualAccountService.validateIndividualDocument(
          this.individualAccount?.cpf,
          file
        )
      );

      this.isValidDocument = data === true;
      this.notifier.notify(
        this.isValidDocument ? 'success' : 'error',
        this.isValidDocument
          ? 'Documento validado com sucesso!'
          : 'Documento inválido. Tente novamente.'
      );
    } catch {
      this.notifier.notify('error', 'Erro ao validar documento.');
    } finally {
      this.loadingValidation = false;
    }
  }

  goBack() {
    this.router.navigate([`${this.tenant}/onboardings/fatca-pep`]);
  }

  formInvalid(): boolean {
    if (!this.confirmData) return true;
    if (!this.individualDocument || !this.isValidDocument) return true;
    return false;
  }

  update() {
    this.loading = true;

    this.individualAccountService
      .uploadIndividualDocument(
        Number(this.individualId),
        this.individualDocument
      )
      .pipe(
        catchError((error) => {
          this.loading = false;
          return throwError(() => error);
        }),
        switchMap(() => this.authService.account()),
        switchMap((account) =>
          this.registerService.registerSeeawayPF(account.id)
        ),
        catchError((error) => {
          this.loading = false;
          return throwError(() => error);
        }),
        switchMap((individual) =>
          this.registerService.putRegisterStep(
            RegisterStepType.ResponsibleDocuments
          )
        ),
        catchError((error) => {
          this.loading = false;
          return throwError(() => error);
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: () => {
          this.notifier.notify(
            'success',
            'Seu cadastro foi realizado com sucesso e seguirá para análise.'
          );
          this.router.navigate([`${this.tenant}/home`]);
        },
      });
  }
}
